<div class="trial-days">
    @switch (true) {
        @case (+trialDays === 0) {
            <div class="trial-days__content">Your trial expires <span class="trial-days__count">today</span></div>
        }
        @case (+trialDays < 0) {
            <div class="trial-days__content">Silo trial is <span class="trial-days__count">expired</span></div>
        }
        @default {
            <div class="trial-days__content">
                Your trial expires in <span class="trial-days__count">{{ trialDays }}</span>
                {{ trialDays === '1' ? 'day' : 'days' }}
            </div>
        }
    }
</div>
